import { render, staticRenderFns } from "./LinkedUser.vue?vue&type=template&id=67c5a798&scoped=true"
import script from "./LinkedUser.vue?vue&type=script&lang=ts"
export * from "./LinkedUser.vue?vue&type=script&lang=ts"
import style0 from "./LinkedUser.vue?vue&type=style&index=0&id=67c5a798&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c5a798",
  null
  
)

export default component.exports